// extracted by mini-css-extract-plugin
export default {"counter":"CancelAssessmentDialog_counter__6kZNQ","serverError":"CancelAssessmentDialog_serverError__1vAW-","field":"CancelAssessmentDialog_field__IgPoW"};